import { Permission } from '../../../../core/enums/permission.enum';
import { PermissionBit } from '../../../../core/utils/permission-types';

export const MENU_PERM_CONFIG: Record<string, PermissionBit[]> = {
dashboard: [
  Permission.DASHBOARD_GLOBAL,
  Permission.DASHBOARD_CLIENT,
  Permission.DASHBOARD_LEADER,
  Permission.DASHBOARD_LANGUAGE,
  Permission.DASHBOARD_PROMOTION,
  ],
  employeesManagement: [Permission.CARDS_VIEW_READ, Permission.CARD_VIEW_VALIDATE_ROLE, Permission.SALARY_VALIDATE, Permission.CONTRACT_ENDING_NOTIFICATION, Permission.TRIAL_PERIOD_ENDING_NOTIFICATION, Permission.JUNIOR_PROMOTION_NOTIFICATION],
  cardsView: [Permission.CARDS_VIEW_READ],
  employeesListView: [Permission.CARDS_VIEW_READ],
  interns: [Permission.INTERNSHIP_LISTS_READ, Permission.INTERNSHIP_LISTS_WRITE],
  employeeValidation: [Permission.CARD_VIEW_VALIDATE_ROLE, Permission.SALARY_VALIDATE],
  roleValidation: [Permission.CARD_VIEW_VALIDATE_ROLE],
  salaryValidation: [Permission.SALARY_VALIDATE],
  employeeNotifications: [Permission.CONTRACT_ENDING_NOTIFICATION, Permission.TRIAL_PERIOD_ENDING_NOTIFICATION, Permission.JUNIOR_PROMOTION_NOTIFICATION],
  contractEndingNotification: [Permission.CONTRACT_ENDING_NOTIFICATION],
  trialPeriodNotification: [Permission.TRIAL_PERIOD_ENDING_NOTIFICATION],
  juniorPromotionNotification: [Permission.JUNIOR_PROMOTION_NOTIFICATION],

  staffing: [Permission.STAFFING_READ, Permission.CLIENT_READ, Permission.PROJECT_READ, Permission.POOL_READ, Permission.POOL_WRITE],
  performanceManagement: [
    Permission.PROMOTION_READ,
    Permission.PROMOTION_IDENTIFY_CANDIDATE,
    Permission.PROMOTION_CONFIRM_IDENTIFICATION,
    Permission.PROMOTION_COMMIT,
    Permission.PROMOTION_SCHEDULE_INTERVIEW,
    Permission.PROMOTION_MANAGE_CANDIDATE,
    Permission.EVALUATION_READ,
    ],
  finance: [Permission.INVOICING_READ, Permission.INVOICING_SERVICE, Permission.INVOICING_ADMIN],
  group: [Permission.INVOICING_READ, Permission.INVOICING_SERVICE, Permission.INVOICING_ADMIN],
  process: [Permission.INVOICING_READ, Permission.INVOICING_SERVICE, Permission.INVOICING_ADMIN],

  // Production section: only holders of the PRODUCTION permission see it.
  production: [Permission.PRODUCTION, Permission.PEOPLE_READ, Permission.MANAGER_READ],
  productionService: [Permission.INVOICING_READ, Permission.INVOICING_SERVICE, Permission.INVOICING_ADMIN],
  productionUnsigned: [Permission.PRODUCTION, Permission.PEOPLE_READ, Permission.MANAGER_READ],
  productionWithSupervisor: [Permission.PRODUCTION, Permission.PEOPLE_READ, Permission.MANAGER_READ],

  client: [Permission.CLIENT_READ],
  project: [Permission.PROJECT_READ],
  staff: [Permission.STAFFING_READ],
  pool: [Permission.POOL_READ, Permission.POOL_WRITE],

  promotion: [
    Permission.PROMOTION_READ,
    Permission.PROMOTION_IDENTIFY_CANDIDATE,
    Permission.PROMOTION_CONFIRM_IDENTIFICATION,
    Permission.PROMOTION_COMMIT,
    Permission.PROMOTION_SCHEDULE_INTERVIEW,
    Permission.PROMOTION_MANAGE_CANDIDATE,
    ],
  evaluation: [Permission.EVALUATION_READ],

  evaluation_campaigns: [Permission.EVALUATION_WRITE],
  evaluation_my: [Permission.EVALUATION_READ],
  evaluation_self: [Permission.EVALUATION_READ],
  evaluation_assign: [Permission.EVLUATION_ASSIGN_REVIEWERS],
  evaluation_remuneration: [
    Permission.MANAGER_READ, Permission.MANAGER_WRITE, Permission.MANAGER_PEOPLE,
    Permission.PEOPLE_READ, Permission.PEOPLE_WRITE, Permission.DIRECTOR_READ, Permission.DIRECTOR_WRITE,
    Permission.EVALUATION_READ, Permission.EVALUATION_WRITE
  ],
  evaluation_review_impact: [
    Permission.MANAGER_READ, Permission.MANAGER_WRITE, Permission.MANAGER_PEOPLE,
    Permission.PEOPLE_READ, Permission.PEOPLE_WRITE, Permission.DIRECTOR_READ, Permission.DIRECTOR_WRITE, Permission.EVALUATION_WRITE,
  ],

  feedbackAll: [Permission.FEEDBACK_ASSIGNMENT_MANAGER],
  // feedback managers and handlers can both see Assigned feedback.
  feedbackAssigned: [Permission.FEEDBACK_ASSIGNED_HANDLER],

  serviceTeam: [Permission.INVOICING_READ, Permission.INVOICING_SERVICE, Permission.INVOICING_ADMIN],
  // BSA Team Management
  bsaOrg: [Permission.BSA_ORG_READ],
  bsaOrgWrite: [Permission.BSA_ORG_WRITE],
  audit_log: [Permission.AUDIT_LOG_READ],

  opportunities: [Permission.OPPORTUNITY_READ, Permission.DEMAND_READ, Permission.PEOPLE_WITH_BAD_ATTITUDE_READ, Permission.PEOPLE_AT_RISK_READ],
  opportunitiesList: [Permission.OPPORTUNITY_READ],
  demandes: [Permission.DEMAND_READ],
  badAttitude: [Permission.PEOPLE_WITH_BAD_ATTITUDE_READ],
  release: [Permission.PEOPLE_AT_RISK_READ],
};
